/**
 * @ngInject
 */
/**
 *  we user this function to call Laravel API from Javascript and send data back to UserStore..
 *
 */
function DataService($q, $http) {
    var api = {};

    api.getUser = function() {
        return $http.get('/api/authenticate');
    };

    api.updateUser = function(data) {
        return $http.put(
            '/api/authenticate',
            data
        );
    };

    api.deleteUser = function() {
        return $http.delete(
            '/api/authenticate',
            {}
        );
    };

    return api;
}